// TeamMember.js
import React, { useState } from 'react';
import { HiXCircle } from "react-icons/hi";

const TeamMember = ({ imageSrc, firstname, lastname, title, biography }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const formatBiography = (biography, breakPoints) => {
    for (const point of breakPoints) {
      biography = biography.replace(point, `\n${point}`);
    }
    return biography;
  };

  const formattedBiography = formatBiography(biography, [
    '. From',
  ]);

  return (
    <>
      <div className="team-card" onClick={handleOpenModal}>
        <img src={imageSrc} alt={firstname} className="team-image" />
        <div className="team-info">
          <h3>{firstname}</h3>
          <h3>{lastname}</h3>
          <p>{title}</p>
        </div>
      </div>

      {isModalOpen && (
        <div className="modal-overlay">
          <div className="modal">
            <div className="modal-content">
              <div className="modal-info">
                <h2>{firstname} {lastname}</h2>
                <h3>{title}</h3>
                <p className="biography">{formattedBiography}</p>
              </div>
              <img src={imageSrc} alt={firstname} className="modal-image" />
            </div>
            <button className="modal-close-button" onClick={handleCloseModal}> 
            <HiXCircle />
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default TeamMember;